import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { RowElement } from '@framework/ui/components/row/RowElement.tsx';
import { WidgetConfigurationSlotRender } from '../../widgets/repository/common/config-slots/WidgetConfigurationSlotRender.tsx';
import { WidgetConfigurationSlots } from '../../widgets/repository/common/config-slots/WidgetConfigurationSlots.tsx';

interface IMarginDirectiveConfigComponentProps {
  name: string;
}

export function MarginDirectiveConfigComponent(
  props: IMarginDirectiveConfigComponentProps,
) {
  const { name } = props;
  return (
    <WidgetConfigurationSlotRender
      slot={WidgetConfigurationSlots.SpecialBehaviors}
    >
      <RowElement>
        <FormItem name={`${name}.top`} label="Margine superiore">
          <NumberInput name={`${name}.top`} min={0} step={1} suffix="px" />
        </FormItem>

        <FormItem name={`${name}.bottom`} label="Margine inferiore">
          <NumberInput name={`${name}.bottom`} min={0} step={1} suffix="px" />
        </FormItem>

        <FormItem name={`${name}.left`} label="Margine sinistro">
          <NumberInput name={`${name}.left`} min={0} step={1} suffix="px" />
        </FormItem>

        <FormItem name={`${name}.right`} label="Margine destro">
          <NumberInput name={`${name}.right`} min={0} step={1} suffix="px" />
        </FormItem>
      </RowElement>
    </WidgetConfigurationSlotRender>
  );
}
